// src/utils/profileUtils.js
import { getAuth, onAuthStateChanged } from 'firebase/auth';

async function waitForAuth() {
  const auth = getAuth();
  if (auth.currentUser) return;
  await new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, () => {
      unsub();
      resolve();
    });
  });
}

export const updatePseudoInTournaments = async (newPseudo) => {
  try {
    await waitForAuth();
    const auth = getAuth();
    const user = auth.currentUser;
    
    if (!user) {
      throw new Error('Please log in again to update your pseudo.');
    }
    
    // Force fresh token to avoid 401 errors
    const token = await user.getIdToken(true);

    // Call the updatePseudoInTournaments function as HTTP request
    const response = await fetch(`https://us-central1-yme-dp-manager.cloudfunctions.net/updatePseudoInTournaments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        newPseudo: newPseudo
      })
    });

    const res = await response.json();
    
    if (!response.ok) {
      throw new Error(res.error || 'Failed to update pseudo in tournaments');
    }

    if (!res?.success) {
      throw new Error(res?.error || 'Failed to update pseudo in tournaments');
    }

    console.log('✅ Pseudo updated in tournaments:', res.tournamentsUpdated);
    return res;
  } catch (error) {
    console.error('❌ Update pseudo in tournaments error:', error?.message || error);
    throw error;
  }
};
